'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactHotkeys = require('react-hotkeys');

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A generic (and mostly semantic) form component.
 */

var Form = function (_PureComponent) {
  (0, _inherits3.default)(Form, _PureComponent);

  function Form(props) {
    (0, _classCallCheck3.default)(this, Form);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.__handlers__ = {
      'meta+return': _this.onSubmitHotkey.bind(_this)
    };
    return _this;
  }

  (0, _createClass3.default)(Form, [{
    key: 'onSubmitHotkey',
    value: function onSubmitHotkey(event) {
      if (this.props.onSubmit) {
        this.props.onSubmit(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children']);


      return React.createElement(
        _reactHotkeys.HotKeys,
        (0, _extends3.default)({ component: 'form', handlers: this.__handlers__ }, otherProps),
        children
      );
    }
  }]);
  return Form;
}(_component2.default);

exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/form/form.js
// module id = 323
// module chunks = 114276838955818